import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Can from '../Can'
import NavigationLabel from '../NavigationLabel/NavigationLabel'
import { NAVIGATION_LABELS } from '../../helpers/constants'

import ResidentEventsLink from './UpsellingLinks/ResidentEventsLink'
import CustomerPortalLink from './UpsellingLinks/CustomerPortalLink'

const ExploreModal = () => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="navmgr-hover-menu-explore">
      <div className="hover-menu-arrow" />
      <div className="navmgr-hover-menu__inner">
        <Can on={'Navbar'} to={'integrationsPM'}>
          <div className="hover-menu-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
              }
              to="/dashboard/integrations"
            >
              <span>
                {t('navbar:upsellingLinks.integrations')}
                <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
              </span>
            </NavLink>
          </div>
        </Can>
        <Can
          on={'Navbar'}
          to={'integrationsPM'}
          feedFlag={'residentEventsAvailable'}
          upsellingLink={<ResidentEventsLink withUpsellingRedirect />}
        >
          <ResidentEventsLink />
        </Can>
        <Can on={'Navbar'} to={'customerPortal'} feedFlag={'customerPortalAvailable'}>
          <CustomerPortalLink />
        </Can>
      </div>
    </div>
  )
}

ExploreModal.propTypes = {}
export default ExploreModal
